var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18C0 22.7739 1.89642 27.3523 5.27208 30.7279C8.64773 34.1036 13.2261 36 18 36C22.7739 36 27.3523 34.1036 30.7279 30.7279C34.1036 27.3523 36 22.7739 36 18C36 13.2261 34.1036 8.64773 30.7279 5.27208C27.3523 1.89642 22.7739 0 18 0C13.2261 0 8.64773 1.89642 5.27208 5.27208C1.89642 8.64773 0 13.2261 0 18Z",
    fill: "#1840B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.4375H27C27.6667 11.4375 28 11.7708 28 12.4375V23.5625C28 24.2292 27.6667 24.5625 27 24.5625H9C8.33333 24.5625 8 24.2292 8 23.5625V12.4375C8 11.7708 8.33333 11.4375 9 11.4375Z",
    fill: "#EAEDF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 24.5625H27C27.5523 24.5625 28 24.1148 28 23.5625V21.75C22.655 17.4167 19.3217 15.25 18 15.25C16.6783 15.25 13.345 17.4167 8 21.75V23.5625C8 24.1148 8.44772 24.5625 9 24.5625Z",
    fill: "#CCDAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.4375H27C27.5523 11.4375 28 11.8852 28 12.4375V14.25C22.3547 18.1667 19.0213 20.125 18 20.125C16.9787 20.125 13.6453 18.1667 8 14.25V12.4375C8 11.8852 8.44772 11.4375 9 11.4375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginMail);
export default __webpack_public_path__ + "static/media/loginMail.9d22553c54e1156e6a45db0d24950a84.svg";
export { ForwardRef as ReactComponent };